import styled, { css } from 'styled-components';

export const visuallyHiddenCss = css`
  position: absolute !important;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
`;

export const VisuallyHidden = styled.span`${visuallyHiddenCss}`;
